import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import {
    BgColorOptions,
    ColorOptions,
    PaddingLeftOptions,
    PaddingRightOptions,
    RatioOptions,
    TextStyleOptions
} from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ShellComponent } from 'projects/app-default/src/app/ui/display/local-shell.component';
export interface IMessage {
    image?: string;
    ratio?: string;
    msg_font_style?: string;
    text?: string;
    color?: string;
    image_padding_right?: string;
    image_padding_left?: string;
    url?: string;
}
export interface IPageComponenTrustMessagesData extends NICmsContentComponent.IData {
    trust_messages: IMessage[];
    bg_color?: string;
    reducePaddingOnX?: boolean;
    reducePaddingOnL?: boolean;
    autoScroll?: boolean;
    animationDuration?: number;
}
@Component({
    selector: 'trust-messages',
    templateUrl: 'trust-messages.html',
    styleUrls: ['trust-messages.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, IfSizeDirective, ICmsClientModule, ImageModule, ShellComponent, HrefComponent, CarouselModule, NgTemplateOutlet]
})
@ICmsComponent<TrustMessagesComponent>({
    id: 'trust_messages_layout',
    name: 'Trust Messages Layout',
    tags: ['Message', 'Trust'],
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'bg_color',
            type: NICmsContentField.EFieldType.choice,
            title: 'Background Colour',
            options: BgColorOptions,
            default: 'bg-col-5',
            colorPreview: true
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'reducePaddingOnX',
            title: 'Reduce padding on X size',
            default: false
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'reducePaddingOnL',
            title: 'Reduce padding on L size',
            default: false
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'autoScroll',
            title: 'Automatic scrolling',
            default: false
        },
        <NICmsContentField.INumberField>{
            key: 'animationDuration',
            title: 'Animation duration',
            type: NICmsContentField.EFieldType.number,
            default: 20,
            min: 0,
            max: 100,
            description: 'Set speed on animation in seconds ( 0 - 100 )'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'trust_messages',
            title: 'Trust Message',
            itemName: 'Message',
            itemNameField: 'Message',
            defaultSize: 4,
            maxSize: data => (data.autoScroll ? undefined : 5),
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'ratio',
                    title: 'Ratio',
                    default: 'ratio-5-1',
                    options: RatioOptions
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'image_padding_right',
                    title: 'Image Padding Right',
                    default: 'p-r-0',
                    options: PaddingRightOptions
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'image_padding_left',
                    title: 'Image Padding left',
                    default: 'p-l-0',
                    options: PaddingLeftOptions
                },
                <NICmsContentField.IChoiceField>{
                    key: 'msg_font_style',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Quote Font Style',
                    options: TextStyleOptions,
                    default: 'p1'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'color',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Font Colour',
                    options: ColorOptions,
                    default: 'col-11'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'text',
                    title: 'Text'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'url',
                    title: 'URL'
                }
            ]
        }
    ]
})
export class TrustMessagesComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: IPageComponenTrustMessagesData;

    override ngOnInit(): void {
        super.ngOnInit();
    }
}
